import { CountrySelectedValue } from "./doctorregistration";
import { SelectItem } from 'primeng/api/selectitem';
import { ApiResult } from "./PromiseResult";
import { OtpData, PasswordInput, utilities, RecaptchaData, TabView_Data, userid_input_data, userid_input_types, REG_EXP, Form_Data, OTP_Validate } from "./util.models";
import { LoginModal, VerifyUserID_Body } from "./Login";
import { AuthResult } from "./AuthResult";
import { ForgotPassword, ForgotPasswordToken } from "./LoginUser";
import { PatientUpdate } from "./PatientAccount";
import { Router } from "@angular/router";


export class patientFetchedData {
    patient_guid: string = "";
    relation: string = "";
    first_name: string = "";
    middle_name: string = "";
    last_name: string = "";
    gender: string = "";
    date_of_birth: string = "";
    address_line_1: string = "";
    address_line_2: string = "";
    city: string = "";
    state_name: string = "";
    state_id: number = null;
    zip_code: string = "";
    country_id: number = null;
    primary_contact_number: string = "";
    secondary_contact_number: string = "";
    avatar_url: string = "";
    avatar_key: string = "";
    medical_record_number: string = "";
    valid_till: string = "";
    identification_type: string = "";
    identification_url: string = "";
    identification_key: string = "";
    user_patient: { id: number; } = { id: null };
    country: { acronym: string; phone_code: number; } = { acronym: "", phone_code: null, };
    final_name: string = "";

}
export class User_Registration {
    email: string = "";
    e_email: string = "";
    e_password: string = "";
    confirmpassword: string = "";
    first_name: string = "";
    middle_name: string = "";
    last_name: string = "";
    gender = "";
    date_of_birth: string = "";
    date_of_birth_date: Date = null;
    state_id: number = null;
    country_id: number = null;
    primary_contact_number: string = "";
    accepted_terms_id: number = 2;
    title: string = "Patient";
    rememberme: boolean = false;
    recaptcha: string = "";
    avatar_url: string = "";
    user_source_id: number = null;
    other_source: string = "";
    provider_id: string = "";
}

export class User_Registration_v2 extends OTP_Validate {
    first_name: string = "";
    middle_name: string = "";
    last_name: string = "";
    state_id: number = null;
    country_id: number = null;
    primary_contact_number: string = "";
    recaptcha: string = "";
    provider_id: string = ""
}

export class Edit_Otp_Api_Data {
    value: string = "";
    // beforealue: string = "";
    // finalValue: string = "";
    isEdit: boolean = false;
    has_verified: boolean = true;
    edit_api_result: ApiResult = new ApiResult(false);
    otp_data: OtpData = new OtpData(0);
    data: userid_input_data = new userid_input_data(userid_input_types.all);
    tabViewData: TabView_Data = new TabView_Data(0, 1);
    constructor(input_type: 0 | 1 | 2) {
        this.data = new userid_input_data(input_type);
    }

    reset_data() {
        this.isEdit = false;
        this.edit_api_result = new ApiResult(false);
        this.otp_data = new OtpData(0);
        this.tabViewData = new TabView_Data(0, 1);
    }
}

export class Members {
    currentGUID: string = "";
    data: SelectItem[] = [];
    api_result: ApiResult = new ApiResult(false);
}
export class patientEdit_Data {
    members: Members = new Members();
    // patientEditForm_api_result: ApiResult = new ApiResult(false);
    patientEditForm_Data: PatientUpdate = new PatientUpdate();
    other_data: patientEditOtherData = new patientEditOtherData();
    patient_update_api_result: ApiResult = new ApiResult(false);
    form_data: Form_Data = new Form_Data();
    patientFetchedCurrentData: patientFetchedData = new patientFetchedData();
    // profileCompletion: verifyRegistration_Data = new verifyRegistration_Data();
}

// export class verifyRegistration_Data {
//     patient_guid: string = "";
//     date_of_birth: string = "";
//     date_of_birth_date: Date = null;
//     state_name: string = "";
//     state_id: string = "";
//     gender: string = "";
//     max_date: Date = new Date();
//     selectedState: { id: string, name: string } = null;
// }

export class patientEditOtherData {
    states: SelectItem[] = [];
    country: SelectItem[] = [];
    unique_id: SelectItem[] = [];
    // max_date: Date = new Date();
    // selectedState: { id: string, name: string } = null;
}

export class passwordEditData {
    password_edit_api: password_edit_api = new password_edit_api();
    new_password: PasswordInput = new PasswordInput();
    current_password: PasswordInput = new PasswordInput();
    confirm_password: PasswordInput = new PasswordInput();
    api_result: ApiResult = new ApiResult(false);
}

export class password_edit_api {
    password_change: boolean = false;
    prev_password: string = "";
    confirm_password: string = "";
    e_password: string = "";
    first_name: string = null;
    middle_name: string = null;
    last_name: string = null;
    date_of_birth: string = null;

    resetFields() {
        this.prev_password = "";
        this.confirm_password = "";
        this.e_password = "";
        this.first_name = null;
        this.middle_name = null;
        this.last_name = null;
        this.date_of_birth = null;
    }

}
export class Edit_Data extends utilities {
    userid_types = userid_input_types;
    mobile_email_fetch_api_result: ApiResult = new ApiResult(false);
    mobileData: Edit_Otp_Api_Data = new Edit_Otp_Api_Data(this.userid_types.phone_number);
    emailData: Edit_Otp_Api_Data = new Edit_Otp_Api_Data(this.userid_types.email);
    userGuid: string = "";
    reg_exp: REG_EXP = new REG_EXP();
    patientEdit_Data: patientEdit_Data = new patientEdit_Data();
    password_edit: passwordEditData = new passwordEditData();

}

export class VerifyUserid_Data {
    verify_api_result: ApiResult = new ApiResult(false);
    userid_data: userid_input_data = new userid_input_data(userid_input_types.all);
    verify_modal: VerifyUserID_Body = new VerifyUserID_Body();
    return_url: string = null;
    auth_result: AuthResult = new AuthResult();
    recaptchaData: RecaptchaData = new RecaptchaData();
    password_input: PasswordInput = new PasswordInput();
    otp_data: OtpData = new OtpData(0);
    tabViewData: TabView_Data = new TabView_Data(0, 2);
}

export class Login_Data extends utilities {
    login_api_result: ApiResult = new ApiResult(false);
    userid_data: userid_input_data = new userid_input_data(userid_input_types.all);
    login_modal: LoginModal = new LoginModal();
    return_url: string = null;
    auth_result: AuthResult = new AuthResult();
    recaptchaData: RecaptchaData = new RecaptchaData();
    password_input: PasswordInput = new PasswordInput();
    otp_data: OtpData = new OtpData(0);
    tabViewData: TabView_Data = new TabView_Data(0, 2);
    show_otp_input: boolean = false;
    show_otp_button: boolean = true;
    goBack(url: string, router: Router) {
        if (this.tabViewData.selected_tab == 0 && this.getEmptyStringChecker(url)) {
            router.navigate([url]);
        }
        else if (this.tabViewData.selected_tab != 0) {
            this.login_api_result = new ApiResult(false);
            this.otp_data.otp_api_result = new ApiResult(false);
            this.resetRecapPass();
            this.tabViewData.prevTab(0);
        }
    }

    resetRecapPass() {
        this.login_modal.password = "";
        this.login_modal.recaptcha = "";
    }

    async toggleLoginType(is_email: boolean) {
        this.userid_data.toggleLoginType(is_email);
        this.login_modal.password = "";
        await this.userid_data.reset();
        this.otp_data.OTP_validate_api.is_password = false;
        this.show_otp_input = false;
        this.show_otp_button = true;
        this.login_api_result = new ApiResult(false);
        this.otp_data = new OtpData();
        this.userid_data.isDisabled = false;
    }

    disabled(): boolean {
        if (this.otp_data.OTP_validate_api.is_password) {
            return !Boolean(this.login_modal.password);
        }
        else {
            return !Boolean(this.otp_data.OTP_validate_api.token);
        }
    }
}

export class ForgotPasswordData {
    forgot_api_result: ApiResult = new ApiResult(false);
    userid_data: userid_input_data = new userid_input_data(userid_input_types.all);
    body: ForgotPassword = new ForgotPassword();
    tokenBody: ForgotPasswordToken = new ForgotPasswordToken();
    return_url: string = null;
    auth_result: AuthResult = new AuthResult();
    recaptchaData: RecaptchaData = new RecaptchaData();
    password_input: PasswordInput = new PasswordInput();
    otp_data: OtpData = new OtpData();
    tabViewData: TabView_Data = new TabView_Data(0, 2);
}

export class Patient_Registration_Other_Data {
    selected_country: string = "";
    selected_country_acronym: string = "";
    primary_contact_no: string = "";
    selected_country_data: CountrySelectedValue = new CountrySelectedValue();
    // phone_code: string = "";
    // formPosting: boolean = false;
    // isPassword: boolean = true;
    recaptchaData: RecaptchaData = new RecaptchaData();
    // recaptcha_Reset: boolean = false;
    // registrationDone: boolean = false;
    // recaptcha: any = "";
    countries: SelectItem[] = [];
    states: SelectItem[] = [];
    sources: SelectItem[] = [];
    terms_and_conditions_url: string = "";
    terms_and_conditions_checkbox: boolean = false;
    // tipsPasswordShowed: boolean = false;
    max_date: Date = new Date();
    tabViewData: TabView_Data = new TabView_Data(0, 1);
    password_input: PasswordInput = new PasswordInput();
}

export class Patient_Registration_Api_Data {
    userPatient: User_Registration = new User_Registration();
    userPatientv2: User_Registration_v2 = new User_Registration_v2();
    create_api_result: ApiResult = new ApiResult(false);
    otp_data: OtpData = new OtpData(0);
    auth_result: AuthResult = new AuthResult();
}

export class Patient_Registration_Data {

    other_data: Patient_Registration_Other_Data = new Patient_Registration_Other_Data();
    api_data: Patient_Registration_Api_Data = new Patient_Registration_Api_Data();
    constructor(terms_and_conditions_url?: string, max_date?: Date) {
        this.other_data.terms_and_conditions_url = terms_and_conditions_url;
        this.other_data.max_date = max_date;
    }
}

export class PhoneNumberExists {
    primary_contact_number: string = "";
    recaptcha: string = "";
}

export interface ResetPassword {
    e_password: string;
    token: string;
    egd_token: string;
    recaptcha: string;
}

export interface UserLoginOptions {
    name: string;
    register_url: string;
    home_back_url: string;
    forget_back_url: string;
    base_url: string;
}


export interface Sources {
    user_source_id: number,
    user_source: string

}

export interface CurrentUserData {
    selected_user_type: string;
    user_type_data: UserTypeData[],
    user_types: UserTypes;
}

export interface UserTypeData {
    user_type: string;
    text_data: string;
}

export interface UserTypes {
    'PATIENT': string;
    'DOCTOR': string;
    'OTHER-MEDICAL-PROFESSIONALS': string;
    'SUPPORT': string;
    'VENDOR': string;
}